export default __webpack_public_path__ + "static/media/reports.e9dbb58d.svg";